<div class="textarea" [attr.data-testid]="'file-textarea'">
  <a
    [href]="message.content.content"
    target="_new"
    [attr.data-testid]="'file-download-link'"
  >
    <div class="icon" [attr.data-testid]="'file-icon'">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
        <!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
        <path
          d="M384 128h-128V0L384 128zM256 160H384v304c0 26.51-21.49 48-48 48h-288C21.49 512 0 490.5 0 464v-416C0 21.49 21.49 0 48 0H224l.0039 128C224 145.7 238.3 160 256 160zM255 295L216 334.1V232c0-13.25-10.75-24-24-24S168 218.8 168 232v102.1L128.1 295C124.3 290.3 118.2 288 112 288S99.72 290.3 95.03 295c-9.375 9.375-9.375 24.56 0 33.94l80 80c9.375 9.375 24.56 9.375 33.94 0l80-80c9.375-9.375 9.375-24.56 0-33.94S264.4 285.7 255 295z"
        />
      </svg>
    </div>
    <div class="right" [attr.data-testid]="'file-info'">
      <h3 i18n [attr.data-testid]="'file-title'">儲存檔案</h3>
      <div class="filename" [attr.data-testid]="'file-name'">
        {{ message.content.title }}
      </div>
    </div>
  </a>
</div>

<div
  class="arrow"
  [ngClass]="{ receive: message.direction === 'Receive' }"
  [attr.data-testid]="'file-direction-arrow'"
></div>
